export default __webpack_public_path__ + "static/media/neet_reg_desktop.40cafc6a.png";